import { Gender } from "../types/user";

export const renderGenderInHebrew = (gender: Gender) => {
    return gender === Gender.MALE ? 'זכר' : 'נקבה';
};
